'use client'

import { useCallback, useMemo, useState } from 'react'
import { ImportedFieldKey } from '@/app/utils/loan/loan-pdf-extract-merge'

export const useLoanPdfImportState = () => {
    const [importedFields, setImportedFields] = useState<ReadonlySet<ImportedFieldKey>>(new Set())

    const clearImported = useCallback((key: ImportedFieldKey) => {
        setImportedFields((current) => {
            if (!current.has(key)) return current
            const next = new Set(current)
            next.delete(key)
            return next
        })
    }, [])

    const isImported = useCallback((key: ImportedFieldKey) => importedFields.has(key), [importedFields])

    const value = useMemo(
        () => ({ importedFields, isImported, clearImported }),
        [importedFields, isImported, clearImported]
    )

    return { value, setImportedFields }
}
